export const textInputClasses = {
  input: 'b--none bg-void-grey focus-outline-0 ph6 pv4 min-w14 w-100 mt3'
}

export const checkboxInputClasses = {
  input: 'mt6 ml7'
}
